import { TaskGroup } from "@/api/task-api";

export default function TaskGroupFormData(taskGroup: TaskGroup): FormData {
  const d = new FormData();
  d.append("projectId", String(taskGroup.projectId));
  d.append("taskGroup[id]", String(taskGroup.taskGroupId));
  d.append("taskGroup[order]", String(taskGroup.order));
  d.append("taskGroup[taskTypeId]", String(taskGroup.taskTypeId));
  d.append("taskGroup[officeId]", String(taskGroup.officeId));
  d.append("taskGroup[serviceTaskTypeId]", String(taskGroup.serviceTaskTypeId));
  d.append("taskGroup[staffId]", String((taskGroup as any).staffId)); // FIXME staffIdってなかったっけ？
  return d;
}
